<template>
  <fieldset
    v-if="options?.length > 0"
    :class="{ required: required }"
    :aria-invalid="!!errorMessage"
    :aria-describedby="`${id}-error`"
  >
    <legend class="bold">{{ label }}{{ required ? " *" : "" }}</legend>
    <FormCheckbox
      v-for="option in options"
      :id="prefixId(option.id)"
      :key="option._uid"
      :name="option.id"
      :label="option.label"
      @change="handleChange"
    />
    <p
      v-if="!!errorMessage"
      :id="`${prefixId(id)}-error`"
      role="alert"
      class="form-error"
    >
      {{ errorMessage }}
    </p>
  </fieldset>
</template>

<script setup>
import { useField } from "vee-validate";
import { v4 as uuidv4 } from "uuid";

const props = defineProps({
  options: {
    type: Array,
    required: false,
    default: () => {
      return [];
    },
  },
  label: {
    type: String,
    required: false,
    default: "",
  },
  id: {
    type: String,
    required: false,
    default: "",
  },
  rules: {
    type: [String, Object],
    required: false,
    default: "",
  },
  required: {
    type: Boolean,
    required: false,
  },
});

const uuid = ref(uuidv4());

const rules = computed(() => {
  if (props.rules) return props.rules;
  if (props.required) return "required";
});
const { value: checkboxesValue, errorMessage } = useField(props.id, rules);

const updateCheckedState = () => {
  const checkboxes = Array.from(
    document.querySelectorAll(
      '.form-builder-section fieldset.required input[type="checkbox"]'
    )
  );
  const isChecked = checkboxes.filter((item) => {
    return item.checked == true;
  });
  checkboxesValue.value = isChecked.length > 0 ? true : false;
};

const handleChange = () => {
  updateCheckedState();
};

const prefixId = (value) => {
  return `${uuid.value}-${value}`;
};
</script>

<style lang="scss" scoped>
fieldset {
  margin-top: 2rem;
  legend {
    font-size: 1.5em;
  }
  div {
    margin-top: 0.5rem;
  }
} 
</style>
